import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MainButton from '../../../components/MUI/MainButton';

import useStyles from './makeStyles';

const AddNewMemberButton = ({
  isDeviceLgSize,
  disabled,
  handleAddNewMember,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.memberFormContainer}>
      <MainButton
        disabled={disabled}
        variant="outlined"
        color="primary"
        width={isDeviceLgSize ? 'fullWidth' : 'medium'}
        onClick={() => handleAddNewMember({})}
      >
        <AddCircleOutlineIcon className={classes.icon} />
        <Typography color="primary">{t('travelContract.addMember')}</Typography>
      </MainButton>
    </div>
  );
};

AddNewMemberButton.propTypes = {
  isDeviceLgSize: PropTypes.bool,
  disabled: PropTypes.bool,
  handleAddNewMember: PropTypes.func,
};

AddNewMemberButton.defaultProps = {
  isDeviceLgSize: false,
  disabled: false,
  handleAddNewMember: () => {},
};

export default AddNewMemberButton;
